// extracted by mini-css-extract-plugin
export var dividerContainer = "_9a-0";
export var line = "_9a-1";